import DataGrid, { Column, Pager, Paging, Scrolling, SearchPanel, Selection, Summary, TotalItem } from 'devextreme-react/cjs/data-grid';
import useHasPermission from 'hooks/useHasPermission';
import React, { useRef, useState, useEffect } from 'react'
import { Card } from 'react-bootstrap';
import notistack from 'pages/Core/Notistack';
import POprocessModal from './components/POprocessModal';
import { getItemMasterDropDown, getSubCategoryByCategoryId } from 'pages/Componets/ItemMaster/components/itemMaster/services';
import { useForm, useWatch } from 'react-hook-form';
import { RenderInput } from 'pages/Componets/ItemMaster/model/FieldConfig';
import { getSearchPoProductList } from './services/po.services';
import { productHeaderFields } from './components/fieldConfig';

const ProductList = () => {
    const HasPermission = useHasPermission()
    const [refreshKey, setRefreshKey] = useState(0);
    const [productData, setProductData] = useState<any[]>([])
    const [headerFields, setHeaderFields] = useState<any[]>(productHeaderFields);

    const {
        register,
        reset,
        control,
        watch,
        setValue,
        formState: { errors, isSubmitting },
    } = useForm<any>({
        mode: 'onChange',
        defaultValues: {
            styleNumber: "",
            materialType: "",
            karat: "",
            category: "",
            subCategory: "",
            metalColor: ""
        }
    });

    const selectedRowsRef = useRef<any[]>([]);
    const dataGridRef = useRef<any>(null);
    const [poModalOpen, setPoModalOpen] = useState(false);

    const selectedCategory = watch("category");

    const formValues = useWatch({
        control
    });

    const mapOptions = (data: any[]) =>
        data?.map(item => ({
            label: item.text,
            value: item.value
        })) || [];

    useEffect(() => {
        fetchDropdowns();
    }, []);

    useEffect(() => {
        if (!selectedCategory) {
            setHeaderFields(prev =>
                prev.map(field =>
                    field.name === "subCategory"
                        ? { ...field, options: [] }
                        : field
                )
            );
            setValue("subCategory", "");
            return;
        }

        const loadSubCategory = async () => {
            try {
                const res = await getSubCategoryByCategoryId(selectedCategory);
                setHeaderFields(prev =>
                    prev.map(field =>
                        field.name === "subCategory"
                            ? { ...field, options: mapOptions(res || []) }
                            : field
                    )
                );
            } catch (err) {
                console.error("Subcategory load failed", err);
            }
        };

        loadSubCategory();
    }, [selectedCategory, setValue]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const hasValue = Object.values(formValues || {}).some(value =>
                value && String(value).trim() !== ""
            );

            if (hasValue) {
                onSubmitForm(formValues);
            } else {
                setProductData([]);
            }
        }, 500);

        return () => clearTimeout(timeoutId);
    }, [JSON.stringify(formValues)]);

    const fetchDropdowns = async () => {
        try {
            const res = await getItemMasterDropDown();
            const data = res.data;

            setHeaderFields(prev =>
                prev.map(field => {
                    switch (field.name) {
                        case "styleNumber":
                            return { ...field, options: mapOptions(data.styleMaster) };
                        case "materialType":
                            return { ...field, options: mapOptions(data.materialType) };
                        case "category":
                            return { ...field, options: mapOptions(data.category) };
                        case "metalColor":
                            return { ...field, options: mapOptions(data.metalColoe) };
                        case "karat":
                            return { ...field, options: mapOptions(data.karat) };
                        default:
                            return field;
                    }
                })
            );

        } catch (err) {
            console.error("Dropdown load failed", err);
        }
    };

    const onSubmitForm = async (formData: any) => {
        try {
            const payload = {
                styleId: formData?.styleNumber?.trim() || null,
                materialTypeId: formData?.materialType?.trim() || null,
                karatTypeId: formData?.karat?.trim() || null,
                categoryId: formData?.category?.trim() || null,
                subCategoryId: formData?.subCategory?.trim() || null,
                metalColorId: formData?.metalColor?.trim() || null,
            }

            const response = await getSearchPoProductList(payload)

            if (response.data && Array.isArray(response.data) && response.data.length > 0) {
                setProductData(response.data)
            } else {
                setProductData([])
                if (Object.values(formData).some(v => v && String(v).trim() !== "")) {
                    notistack.info('No products found for the selected filters.');
                }
            }
        } catch (error: any) {
            notistack.error(error)
            setProductData([])
        }
    };

    const reloadDataSource = () => {
        setRefreshKey((prev) => prev + 1);
    };

    const handleSelection = (e: any) => {
        selectedRowsRef.current = e.selectedRowsData;
    };

    const handleButtonClick = () => {
        if (!Boolean(selectedRowsRef.current && selectedRowsRef.current.length > 0)) {
            return notistack.warning('Please select at least one product.')
        }
        setPoModalOpen(true)
    };

    const handlePOClose = () => {
        selectedRowsRef.current = [];
        setPoModalOpen(false);
        dataGridRef.current?.instance?.clearSelection();
    };

    const handleClearFilters = () => {
        reset({
            styleNumber: "",
            materialType: "",
            karat: "",
            category: "",
            subCategory: "",
            metalColor: ""
        });
        setProductData([]);
        selectedRowsRef.current = [];
        dataGridRef.current?.instance?.clearSelection();
    };

    return (
        <>
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5 className="m-0">PO Process</h5>
                            {HasPermission("GoldRateMaster.Write") && (
                                <div className='d-flex justify-content-between align-items-end gap-2'>
                                    <button
                                        type="button"
                                        onClick={handleClearFilters}
                                        className="btn btn-sm"
                                        style={{ border: "1px solid #000" }}
                                    >
                                        Clear Filters
                                    </button>
                                    <button
                                        onClick={handleButtonClick}
                                        className="btn btn-sm"
                                        style={{ border: "1px solid #000" }}
                                    >
                                        PO Creation
                                    </button>
                                </div>
                            )}
                        </Card.Header>
                        <Card.Body>

                            <div className="row g-2">
                                {headerFields.map((f) => (
                                    <RenderInput
                                        key={f.name}
                                        placeholder={`Select ${f.label}`}
                                        field={f}
                                        register={register}
                                        errors={errors}
                                        control={control}
                                    />
                                ))}
                            </div>

                            {HasPermission("Customer.Read") ? (
                                <DataGrid
                                    ref={dataGridRef}
                                    dataSource={productData}
                                    remoteOperations={{ groupPaging: true }}
                                    showRowLines={true}
                                    keyExpr="id"
                                    key={refreshKey}
                                    showBorders={true}
                                    onContentReady={(e) => {
                                        const hasData = e.component.totalCount() > 0;
                                        e.component.option("pager.visible", hasData);
                                        e.component.option("paging.visible", hasData);
                                    }}
                                    onSelectionChanged={handleSelection}
                                    noDataText={productData.length === 0 ? "Select filters to find products" : "No products found"}
                                >
                                    <Selection mode='multiple' />
                                    <Pager showPageSizeSelector allowedPageSizes={[10, 25, 50, 100]} showNavigationButtons displayMode="full" showInfo />
                                    <Scrolling mode="standard" useNative scrollByContent scrollByThumb />
                                    <SearchPanel visible width={240} placeholder="Search..." />
                                    <Summary>
                                        <TotalItem />
                                    </Summary>
                                    <Paging defaultPageSize={10} />

                                    <Column dataField="id" dataType="number" sortOrder="desc" width={150} visible={false} />
                                    <Column dataField="productName" caption="Product Name" width={150} />
                                    <Column dataField="styleNo" caption="Style No" width={150} />
                                    <Column dataField="materialType" caption="Material Type" width={150} />
                                    <Column dataField="karat" caption="Karat" width={150} />
                                    <Column dataField="metalColor" caption="Metal Color" width={150} />
                                    <Column dataField="category" caption="Category" width={150} />
                                    <Column dataField="subCategory" caption="SubCategory" width={120} />
                                    <Column dataField="size" caption="Size" width={100} format="#0.00" />
                                    <Column dataField="weight" caption="Gross Weight" width={140} format={{ type: "fixedPoint", precision: 3 }} />
                                    <Column dataField="netWeight" caption="Net Weight" width={140} format={{ type: "fixedPoint", precision: 3 }} />
                                    <Column dataField="diamondQty" caption="Diamond Qty" width={130} format={{ type: "fixedPoint", precision: 2 }} />
                                    <Column dataField="stoneType" caption="Stone Type" width={140} />
                                    <Column dataField="makingType" caption="Making Type" width={140} />
                                    <Column dataField="collorStoneWeight" caption="Color Stone Wt" width={150} format={{ type: "fixedPoint", precision: 2 }} />
                                </DataGrid>
                            ) : null}

                        </Card.Body>
                    </Card>
                </div>
            </div>

            <POprocessModal
                isPoOpen={poModalOpen}
                onClose={handlePOClose}
                selectedRowsRef={selectedRowsRef.current}
                reloadDataSource={reloadDataSource}
            />
        </>
    )
}

export default ProductList;